<template>
  <div>
    <a href="http://ztjy.people.cn/" target="_blank"> <img src="../../assets/img/xy20d.jpg" width="1920" height="293" style="width: 100%;" /></a>
    <topmenu></topmenu>

    <div class="container">

      <div class="column1">
        <!--服务平台-->
        <div class="fuwupingtai"><fuwupingtai></fuwupingtai></div>
        <!--轮播-->
        <div class="lunbo"><lunbo></lunbo></div>
        <!--通知公告-->
        <tongzhigonggao></tongzhigonggao>
      </div>

      <div class="column2">
        <!--政府信息公开-->
        <zhengfuxinxigongkai></zhengfuxinxigongkai>
        <!--新闻动态-->
        <div class="xinwendongtai"><xinwendongtai></xinwendongtai></div>
        <!--大事记-->
        <div class="dashiji"><dashiji></dashiji></div>
      </div>

      <div class="column3">
        <!--理事长信箱-->

          <lishizhang></lishizhang>

        <!--基层信息-->

          <jicengxinxi></jicengxinxi>

        <!--tab切换-->
         <tabthree></tabthree>

      </div>
      <div class="zt20d">
        <a  href="/#/List?menuid=50&text=%E5%AD%A6%E4%B9%A0%E8%B4%AF%E5%BD%BB%E4%BA%8C%E5%8D%81%E5%A4%A7" ><img src="../../assets/img/mid12d.png" style="width: 49%;" /></a>
        <a  href="/#/List?menuid=51&text=主题教育" ><img src="../../assets/img/midztjy.jpg" style="width: 49%;" /></a>
        <a  href="https://www.cdpf.org.cn/ztzl/zxzt1/2024/2024nqglh/" target="_blank"><img src="../../assets/img/xy20c.jpg" style="width: 99%;padding-right: 6px;margin-top: 3px;" /></a>
      </div>

      <!-- 专题图片 -->
     <zhuanti></zhuanti>

      <div class="column4">
        <!-- 康复工作 -->
        <picbox1></picbox1>
        <!-- 教育就业 -->
         <picbox2></picbox2>
        <!-- 残疾人维权 -->
         <picbox3></picbox3>
      </div>

    </div>
    <bottomfooter></bottomfooter>
	<!-- 悬浮 -->
		<div class="xf" style="position: fixed;right: 0;top: 50%;margin-top: -165px;">
			<img src="../../assets/img/006.png" />
		</div>
  </div>
</template>

<script>
import topmenu from '@/views/front/components/topmenu';
import bottomfooter from '@/views/front/components/bottomfooter';
import fuwupingtai from '@/views/front/components/fuwupingtai';
import lunbo from '@/views/front/components/lunbo';
import tongzhigonggao from '@/views/front/components/tongzhigonggao';
import zhengfuxinxigongkai from '@/views/front/components/zhengfuxinxigongkai';
import xinwendongtai from '@/views/front/components/xinwendongtai';
import dashiji from '@/views/front/components/dashiji';
import lishizhang from '@/views/front/components/lishizhang';
import jicengxinxi from '@/views/front/components/jicengxinxi';
import zhuanti from '@/views/front/components/zhuanti';
import picbox1 from '@/views/front/components/picbox1';
import picbox2 from '@/views/front/components/picbox2';
import picbox3 from '@/views/front/components/picbox3';
import tabthree from '@/views/front/components/tabthree'

export default {
  name: 'Index',
  components: {
    topmenu,
    bottomfooter,
    fuwupingtai,
    lunbo,
    tongzhigonggao,
    zhengfuxinxigongkai,
    xinwendongtai,
    dashiji,
    lishizhang,
    jicengxinxi,
    zhuanti,
    picbox1,
    picbox2,
    picbox3,
    tabthree,
    zhuanti
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style>
.column1,
.column2,
.column3,
.column4{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.lunbo {
  width: 480px;
  height: 300px;
}

.zhengfuxinxigongkai {
  width: 200px;
  height: 240px;
}
.lishizhang {
  width: 200px;
  height: 200px;
}
.jicengxinxi {
  width: 480px;
}
.dashiji {
  width: 300px;

}
.zhuanti{
  height:200px;
}
.zt20d{
      margin-top: 20px;
      margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/Front/Index.vue